export function getMediaPreloadKey(mediaItem) {
  return mediaItem?.id || mediaItem?.src || '';
}

export function createMediaPreload(mediaItem) {
  if (!mediaItem?.src || typeof window === 'undefined') {
    return null;
  }

  if (mediaItem.type === 'image') {
    const image = new Image();
    image.decoding = 'async';
    image.src = mediaItem.src;

    return {
      src: mediaItem.src,
      dispose: () => {
        image.src = '';
      },
    };
  }

  return null;
}
